import { keepPreviousData, useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { auditApi, type ActivityQuery } from '../infrastructure/api';

export const PAGE_SIZE = 50;

export type ActivityFilters = Omit<ActivityQuery, 'cursor' | 'limit'>;

export const auditKeys = {
  all: ['audit'] as const,
  feed: (f: ActivityFilters) => [...auditKeys.all, 'feed', f] as const,
  summary: (userId: string) => [...auditKeys.all, 'summary', userId] as const,
  catalog: () => [...auditKeys.all, 'catalog'] as const,
};

/**
 * A linha do tempo, página a página ("Carregar mais" pede a próxima pelo
 * cursor). Trocar o filtro mantém a lista anterior na tela até a nova chegar.
 * Sem atualização periódica: ela rebuscaria todas as páginas já abertas — a
 * lista se atualiza ao voltar para a aba ou pelo botão "Atualizar".
 */
export function useActivityFeed(filters: ActivityFilters) {
  return useInfiniteQuery({
    queryKey: auditKeys.feed(filters),
    queryFn: ({ pageParam }) => auditApi.activity({ ...filters, cursor: pageParam, limit: PAGE_SIZE }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last) => last.next_cursor ?? undefined,
    placeholderData: keepPreviousData,
  });
}

/** Últimos 30 dias de uma pessoa, por categoria. */
export function useActivitySummary(userId: string) {
  return useQuery({ queryKey: auditKeys.summary(userId), queryFn: () => auditApi.summary(userId) });
}

/** Categorias e ações com os rótulos — fixos, vêm do código do back. */
export function useActionCatalog() {
  return useQuery({ queryKey: auditKeys.catalog(), queryFn: auditApi.catalog, staleTime: Infinity });
}
